/* unplugin-vue-components disabled */import script from "./evaluationCategorySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./evaluationCategorySettings.vue?vue&type=script&setup=true&lang=js"

import "./evaluationCategorySettings.vue?vue&type=style&index=0&id=4fb677f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb677f6"]])

export default __exports__